import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState } from "react";
import Toggle from "./components/Toggle";
import ToggleContainer from "./components/ToggleContainer";
import { getClassNameFactory, getRehydratableName } from "../../utilities";
import { InlineContentDisplayStyle } from "./ShowMoreTypes";

var ShowMore = function ShowMore(_ref) {
  var ContentWrapper = _ref.contentWrapper,
      minLength = _ref.minLength,
      inlineText = _ref.inlineText,
      showMoreLabel = _ref.showMoreLabel,
      showLessLabel = _ref.showLessLabel,
      inlineContentDisplayStyle = _ref.inlineContentDisplayStyle,
      children = _ref.children;
  var isInline = inlineText.length !== 0;
  var getClassName = getClassNameFactory(ShowMore.displayName);
  var rootClassName = getClassName({
    states: isInline ? "inline" : ""
  });
  var toggledContainerClassName = getClassName({
    descendantName: "toggle-container"
  });
  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var onToggle = function onToggle() {
    return setIsExpanded(!isExpanded);
  };

  if (isInline) {
    var expandedContentClassName = getClassName({
      descendantName: "contentWrapper",
      modifiers: !isExpanded && inlineContentDisplayStyle
    });

    var DefaultContentWrapper = function DefaultContentWrapper(defaultProps) {
      return /*#__PURE__*/React.createElement("p", defaultProps);
    };

    var ToggleContentWrapper = ContentWrapper || DefaultContentWrapper;
    var showToggle = inlineText.length > minLength;
    return /*#__PURE__*/React.createElement("div", {
      className: rootClassName,
      "data-show-more-label": showMoreLabel,
      "data-show-less-label": showLessLabel,
      "data-rehydratable": getRehydratableName(ShowMore.displayName)
    }, /*#__PURE__*/React.createElement(ToggleContainer, {
      className: toggledContainerClassName,
      isInline: isInline,
      isExpanded: isExpanded,
      ref: containerRef
    }, /*#__PURE__*/React.createElement(ToggleContentWrapper, {
      className: expandedContentClassName
    }, inlineText.substring(0, minLength), isExpanded && showToggle && inlineText.substring(minLength), !isExpanded && showToggle && /*#__PURE__*/React.createElement(React.Fragment, null, "...")), showToggle && /*#__PURE__*/React.createElement(Toggle, {
      isInline: isInline,
      isExpanded: isExpanded,
      onToggle: onToggle,
      showMoreLabel: showMoreLabel,
      showLessLabel: showLessLabel
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName,
    "data-show-more-label": showMoreLabel,
    "data-show-less-label": showLessLabel,
    "data-rehydratable": getRehydratableName(ShowMore.displayName)
  }, /*#__PURE__*/React.createElement(ToggleContainer, {
    isInline: isInline,
    className: toggledContainerClassName,
    isExpanded: isExpanded,
    ref: containerRef
  }, children), /*#__PURE__*/React.createElement(Toggle, {
    isInline: isInline,
    isExpanded: isExpanded,
    onToggle: onToggle,
    showMoreLabel: showMoreLabel,
    showLessLabel: showLessLabel
  }));
};

ShowMore.displayName = "ShowMore";
ShowMore.defaultProps = {
  inlineText: "",
  minLength: 0,
  showLessLabel: "Show Less",
  showMoreLabel: "Show More",
  inlineContentDisplayStyle: InlineContentDisplayStyle.Inline
};
export default ShowMore;